module.exports = __webpack_public_path__ + "img/100ne.61fab656.svg";